var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Apartment",
    transform: "translate(0.049 0.134)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1782",
    "data-name": "Rectangle 1782",
    width: 20,
    height: 20,
    transform: "translate(-0.049 -0.134)",
    fill: "#00286f",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_153657",
    "data-name": "Path 153657",
    transform: "translate(7.738 1.609)",
    fill: "#fff",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.868629455566406 15.81201457977295 L 0.499999612569809 15.81201457977295 L 0.499999612569809 2.483304977416992 C 0.499999612569809 1.389704942703247 1.38970959186554 0.5000048875808716 2.483309507369995 0.5000048875808716 L 7.868629455566406 0.5000048875808716 C 8.96222972869873 0.5000048875808716 9.85193920135498 1.389704942703247 9.85193920135498 2.483304977416992 L 9.85193920135498 13.82870483398438 C 9.85193920135498 14.9223051071167 8.96222972869873 15.81201457977295 7.868629455566406 15.81201457977295 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.483309745788574 0.999995231628418 C 1.665410041809082 0.999995231628418 1 1.6654052734375 1 2.483304977416992 L 1 15.31200504302979 L 7.868629455566406 15.31200504302979 C 8.686529159545898 15.31200504302979 9.35193920135498 14.6465950012207 9.35193920135498 13.82870483398438 L 9.35193920135498 2.483304977416992 C 9.35193920135498 1.6654052734375 8.686529159545898 0.999995231628418 7.868629455566406 0.999995231628418 L 2.483309745788574 0.999995231628418 M 2.483309745788574 -5.7220458984375e-06 L 7.868629455566406 -5.7220458984375e-06 C 9.240119934082031 -5.7220458984375e-06 10.35193920135498 1.111814498901367 10.35193920135498 2.483304977416992 L 10.35193920135498 13.82870483398438 C 10.35193920135498 15.2001953125 9.240119934082031 16.31200408935547 7.868629455566406 16.31200408935547 L 0 16.31200408935547 L 0 2.483304977416992 C 0 1.111814498901367 1.111809730529785 -5.7220458984375e-06 2.483309745788574 -5.7220458984375e-06 Z",
    stroke: "none",
    fill: "#002970"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_153658",
    "data-name": "Path 153658",
    transform: "translate(1.459 4.746)",
    fill: "#fff",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.70842170715332 12.67509651184082 L 2.483311891555786 12.67509651184082 C 1.389711856842041 12.67509651184082 0.5000017881393433 11.78538608551025 0.5000017881393433 10.69178676605225 L 0.5000017881393433 2.483306407928467 C 0.5000017881393433 1.389706373214722 1.389711856842041 0.4999963343143463 2.483311891555786 0.4999963343143463 L 6.70842170715332 0.4999963343143463 L 6.70842170715332 12.67509651184082 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.483311653137207 0.9999961853027344 C 1.665411949157715 0.9999961853027344 1.000001907348633 1.665406227111816 1.000001907348633 2.483305931091309 L 1.000001907348633 10.69178581237793 C 1.000001907348633 11.50968647003174 1.665411949157715 12.17509651184082 2.483311653137207 12.17509651184082 L 6.20842170715332 12.17509651184082 L 6.20842170715332 0.9999961853027344 L 2.483311653137207 0.9999961853027344 M 2.483311653137207 -3.814697265625e-06 L 7.20842170715332 -3.814697265625e-06 L 7.20842170715332 13.17509651184082 L 2.483311653137207 13.17509651184082 C 1.111811637878418 13.17509651184082 1.9073486328125e-06 12.06327629089355 1.9073486328125e-06 10.69178581237793 L 1.9073486328125e-06 2.483305931091309 C 1.9073486328125e-06 1.11181640625 1.111811637878418 -3.814697265625e-06 2.483311653137207 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#002970"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(10.508 5.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M-1547.369,3601.159h1.49",
    transform: "translate(1547.369 -3598.417)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153651",
    "data-name": "Path 153651",
    d: "M-1547.369,3601.159h1.49",
    transform: "translate(1547.369 -3601.159)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M-1547.369,3601.159h1.49",
    transform: "translate(1547.369 -3595.695)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153649",
    "data-name": "Path 153649",
    d: "M-1547.369,3601.159h1.49",
    transform: "translate(1547.369 -3592.972)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M-1547.369,3601.159h1.49",
    transform: "translate(1550.693 -3598.417)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153652",
    "data-name": "Path 153652",
    d: "M-1547.369,3601.159h1.49",
    transform: "translate(1550.693 -3601.159)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M-1547.369,3601.159h1.49",
    transform: "translate(1550.693 -3595.695)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153650",
    "data-name": "Path 153650",
    d: "M-1547.369,3601.159h1.49",
    transform: "translate(1550.693 -3592.972)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(4.51 8.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M-1547.369,3601.159h1.1",
    transform: "translate(1547.369 -3601.159)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M-1547.369,3601.159h1.1",
    transform: "translate(1547.369 -3598.387)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901-2",
    "data-name": "Path 901",
    d: "M-1547.369,3601.159h1.1",
    transform: "translate(1547.369 -3595.615)",
    fill: "none",
    stroke: "#002970",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.e9dd1a70040d30eaa849b308f4066e0e.svg";
export { ForwardRef as ReactComponent };